import * as pivotDataVentas from '../../csi_data/Pivot_Data.json';
import * as pivotDataAgro from '../../csi_data/Cosecha.json';
import * as pivotDataSimetria from '../../csi_data/simetria.json';
import * as pivotDataIri from '../../csi_data/v_iri.json';
import * as pivotDataIsv from '../../csi_data/v_isv.json';
import * as pivotDataIck from '../../csi_data/v_ick.json';
import * as pivotDataIcd from '../../csi_data/v_icd.json';
import * as pivotDataDpv from '../../csi_data/v_dpv.json';
import * as pivotDataContable from '../../csi_data/contabilizado.json';
//import * as pivotDataConsext from '../../csi_data/rips_v_consultas_medicas.json';
//import * as pivotDataHospital from '../../csi_data/rips_v_hospitalizacion.json';
//import * as pivotDataMedicamentos from '../../csi_data/rips_v_medicamentos.json';
//import * as pivotDataSalotrosserv from '../../csi_data/rips_v_otros_servicios.json';
//import * as pivotDataProcedimientos from '../../csi_data/rips_v_procedimientos.json'; 
//import * as pivotDataUrgencias from '../../csi_data/rips_v_urgencias.json';
import * as pivotDataSettings from '../../csi_data/Pivot_DataSettings.json';

let pivotSettings = pivotDataSettings.default;
pivotSettings.ventas.dataSource=pivotDataVentas.default.data;
pivotSettings.iri.dataSource=pivotDataIri.default.v_iri; 
pivotSettings.isv.dataSource=pivotDataIsv.default.v_isv;
pivotSettings.ick.dataSource=pivotDataIck.default.v_ick;
pivotSettings.icd.dataSource=pivotDataIcd.default.v_icd;
pivotSettings.dpv.dataSource=pivotDataDpv.default.v_dpv; 
pivotSettings.contable.dataSource=pivotDataContable.default.contabilizado; 
pivotSettings.agro.dataSource= pivotDataAgro.default.Cosecha;
pivotSettings.simetria.dataSource= pivotDataSimetria.default.simetria;

//pivotSettings.consext.dataSource=pivotDataConsext.default.rips_v_consultas_medicas;  
//pivotSettings.hospital.dataSource=pivotDataHospital.default.rips_v_hospitalizacion;  
//pivotSettings.medicamentos.dataSource=pivotDataMedicamentos.default.rips_v_medicamentos;  
//pivotSettings.salotrosserv.dataSource=pivotDataSalotrosserv.default.rips_v_otros_servicios;  
//pivotSettings.procedimientos.dataSource=pivotDataProcedimientos.default.rips_v_procedimientos;  
//pivotSettings.urgencias.dataSource=pivotDataUrgencias.default.rips_v_urgencias;  


                      
 
export { pivotSettings };

